import { makeStyles } from "@mui/styles";
import ProductionJobDetail from "../ProductionJobDetail";
import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  productionJobDetailContainer: {
    padding: theme.spacing(2)
  },
  tabsContainer: {
    backgroundColor: "#FFF",
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    paddingTop: theme.spacing(2)
  }
}));

const ProductionJobTabs = ({ productionJobs }) => {
  const classes = useStyles();
  const [selectedProductionJobIndex, setSelectedProductionJobIndex] =
    useState(0);

  const handleSelectedProductionJobTabChange = (event, value) => {
    setSelectedProductionJobIndex(value);
  };

  if (!productionJobs) {
    return (
      <Typography variant="body2" color="error">
        Unfortunately, that order could not be located.
      </Typography>
    );
  }

  if (productionJobs.length === 0) {
    return (
      <Typography variant="body2" color="error">
        There are no production jobs on this order.
      </Typography>
    );
  }

  return (
    <div>
      <div className={classes.tabsContainer}>
        <Tabs
          onChange={handleSelectedProductionJobTabChange}
          value={selectedProductionJobIndex}
          variant="scrollable"
          scrollButtons="auto"
        >
          {productionJobs.map(
            ({
              id,
              label,
              totalProductVariantQuantity,
              totalPrice: { formatted }
            }) => (
              <Tab
                key={id}
                label={`${label} (${totalProductVariantQuantity} PCS | ${formatted})`}
              />
            )
          )}
        </Tabs>
      </div>
      <div className={classes.productionJobDetailContainer}>
        <ProductionJobDetail
          orderProductionJobId={productionJobs[selectedProductionJobIndex].id}
        />
      </div>
    </div>
  );
};

export default ProductionJobTabs;
